export function safeGetStorageItem(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetStorageItem(key, value) {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function createClientId(prefix = 'ymb') {
  const uuid = window.crypto?.randomUUID?.();
  if (uuid) return `${prefix}_${uuid}`;

  const randomValues = new Uint32Array(2);
  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(randomValues);
    return `${prefix}_${Date.now().toString(36)}_${Array.from(randomValues).map((value) => value.toString(36)).join('')}`;
  }

  return `${prefix}_${Date.now().toString(36)}`;
}
